import Visibility from "react-visibility-sensor";
import React from "react";
import PropTypes from "prop-types";
import Analytics from "../../service/Analytics";

export default class AnalyticsWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: true,
    };
  }

  onVisible() {
    const { visible } = this.props;

    if (!visible) {
      return;
    }

    Analytics.writeEvent("Element Visible", {
      elementName: visible,
    });

    // disable visibility monitor after it has triggered once
    this.setState({ active: false });
  }

  render() {
    const { active } = this.state;
    const { children } = this.props;

    return (
      <Visibility
        active={active}
        scrollCheck
        delayedCall
        onChange={visible => {
          if (visible) {
            this.onVisible();
          }
        }}
      >
        {children}
      </Visibility>
    );
  }
}

AnalyticsWrapper.propTypes = {
  visible: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.element,
};
